import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


import LayoutData from "./layout.store"
import Diamond from "./diamond.store"
import DataArgs from "./data_args.store"
import Monitoring from "./monitoring.store"

const store = new Vuex.Store({
  modules: {
    diamondData: Diamond,
    layoutData: LayoutData,
    argData: DataArgs,
    monitoringData: Monitoring
  },
})

export default store;